export default __webpack_public_path__ + "static/media/news.eef6126a.svg";